import {autobind} from "core-decorators";
import {action, autorun, computed, observable} from "mobx";

import stages, {Stage} from "@/shared/stages";

const LOCAL_STORAGE_KEY = "stage";

@autobind
export default class StageStore {
  @observable stage: Stage = stages.production;

  constructor() {
    this.setStage(StageStore.loadStageName());
    autorun(() => StageStore.saveStageName(this.stage));
  }

  // Return an object with the headers need to call the netlify function with the current stage
  static get httpHeaders() {
    return {Stage: StageStore.loadStageName()};
  }

  // Load stage name from localStorage
  static loadStageName() {
    return localStorage.getItem(LOCAL_STORAGE_KEY) || "production";
  }

  // Save stage name to localStorage
  static saveStageName(stage: Stage) {
    localStorage.setItem(LOCAL_STORAGE_KEY, stage.name);
  }

  @computed({keepAlive: true})
  get isProduction(): boolean {
    return this.stage.name === "production";
  }

  @computed({keepAlive: true})
  get httpHeaders() {
    return {Stage: this.stage.name};
  }

  @action
  setStage(stageName: string) {
    if (!Object.keys(stages).find((name) => name === stageName)) throw new Error(`Unknown stage "${stageName}"`);
    const typedStageName = stageName as keyof typeof stages;
    this.stage = stages[typedStageName];
  }
}
